import Modal from './Modal';

class SimpleModal extends Modal {
  private selectPlan = this.modal.querySelector('#plan') as HTMLSelectElement;

  cbOnModalClose(): void {}
  cbOnModalOpen(): void {
    if (!this.selectPlan) return;

    const getPlanID = this.openBtn.dataset.selectPlan;
    this.selectPlan.value = getPlanID || '';

    // selectedIndex is -1 when the value matches no option (and in Safari with
    // a `disabled selected` placeholder), so fall back to the first option.
    const planOption =
      this.selectPlan.options[this.selectPlan.selectedIndex] ||
      this.selectPlan.options[0];
    if (!planOption) return;

    // .select-selected is built by FormInputEvents; it is missing if that init
    // failed, so never assume it is there.
    const parent = this.selectPlan.parentElement;
    const label = parent ? parent.querySelector('.select-selected') : null;
    if (label) label.innerHTML = planOption.innerText;
  }
}

export default SimpleModal;
